"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabularPager = void 0;
var react_1 = __importDefault(require("react"));
var Pager_1 = require("./Pager");
/**
 * A preconfigured `Pager` suitable for use with tables containing large
 * datasets.
 */
var TabularPager = function (props) { return (react_1.default.createElement(Pager_1.Pager, __assign({ pageIndicatorPosition: Pager_1.PageIndicatorPosition.Before, pageIndicatorType: Pager_1.PageIndicatorType.CurrentPageAndTotal }, props))); };
exports.TabularPager = TabularPager;
//# sourceMappingURL=TabularPager.js.map